import { useQuery } from '@tanstack/react-query';
import { DEFAULT_GC_TIME } from '@/client/constants';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { EnablementData } from '@/client/types/ai-management';
import { aiKeys, unwrapEnvelope } from './overview.query';

export const ENABLEMENT = '/llm-admin/enablement';

const useEnablementFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (): Promise<EnablementData> => {
    const raw = await request<any>(ENABLEMENT);
    return unwrapEnvelope<EnablementData>(raw);
  }, 'Failed to load provider / model enablement');
};

export const useEnablementQuery = (enabled = true) => {
  const queryFn = useEnablementFn();
  return useQuery({
    queryKey: aiKeys.enablement(),
    queryFn,
    enabled,
    staleTime: 1000 * 15,
    gcTime: DEFAULT_GC_TIME,
  });
};
